
const postCode = [
    {
        officeName: "Barnet",
        postCodes: ["EN5 0","EN5 6","EN5 8","EN5 1","EN5 3","EN5 7","EN5 5","EN5 4","EN5 9","EN5 2"],
        salesRookEmail: "robot+martyngerrarden5@salesrook.com",
    },
    {
        officeName: "Crouch End",
        postCodes: ["N4 1","N8 3","N4 3","N19 3","N8 1","N8 9","N8 2","N8 4","N8 5","N4 4","N8 0","N4 2","N8 7","N8 6","N8 8"],
        salesRookEmail: "robot+martyngerrardn8@salesrook.com",
    },
    {
        officeName: "East Finchley",
        postCodes: ["N2 8","N2 6","N2 7","N6 6","N2 5","N6 5","N6 4","N2 2","N2 0","N2 9","N2 1","N2 3","N2 4"],
        salesRookEmail: "robot+martyngerrardn2@salesrook.com",
    },
    {
        officeName: "Finchley Central",
        postCodes: ["NW11 6","NW4 4","NW4 2","N3 3","NW11 0","NW11 7","N3 6","N3 0","NW11 9","N3 7","N3 1","NW11 8","N3 9","N3 2","N3 5","N3 8","N3 4"],
        salesRookEmail: "robot+martyngerrardn3@salesrook.com",
    },
    {
        officeName: "Kentish Town",
        postCodes: ["NW1 0","NW1 4","NW5 7","NW5 6","NW5 2","NW5 1","NW1 2","NW5 5","NW1 8","N19 4","N7 6","NW5 9","N7 9","NW5 0","NW5 8","N7 8","NW1 9","NW5 4","NW5 3","N7 7","N19 5","NW1 1","NW1 7","NW1 3","N7 0"],
        salesRookEmail: "robot+martyngerrardnw5@salesrook.com",
    },
    {
        officeName: "Mill Hill",
        postCodes: ["HA8 0","NW9 8","HA8 9","HA8 6","NW7 7","NW9 6","NW7 1","NW9 5","NW9 1","NW4 3","NW7 6","HA8 5","NW7 5","NW4 1","HA8 7","NW9 4","NW9 9","NW7 3","NW7 2","NW9 7","NW7 9","NW7 8","NW7 4","NW7 0"],
        salesRookEmail: "robot+martyngerrardnw7@salesrook.com",
    },
    {
        officeName: "Muswell Hill",
        postCodes: ["N10 7","N22 5","N10 4","N22 7","N11 2","N10 1","N10 2","N10 8","N10 6","N10 5","N10 3","N10 0","N22 6","N10 9","N22 8"],
        salesRookEmail: "robot+martyngerrardn10@salesrook.com",
    },
    {
        officeName: "North Finchley",
        postCodes: ["N12 7","N12 3","N12 5","N12 2","N11 3","N12 8","N12 1","N12 9","N12 0","N12 4","N12 6"],
        salesRookEmail: "robot+martyngerrardn12@salesrook.com",
    },
    {
        officeName: "Whetstone",
        postCodes: ["N20 3","N20 5","N11 1","N20 1","N20 4","N20 2","N20 6","N20 8","N20 9","N20 7","EN4 8","N20 0","EN4 0","EN4 1","EN4 2","EN4 3","EN4 4","EN4 5","EN4 6","EN4 7","EN4 9"],
        salesRookEmail: "robot+martyngerrardn20@salesrook.com",
    },
    {
        officeName: "Winchmore Hill",
        postCodes: ["N21 4","N21 1","N13 6","N21 9","N14 5","EN2 7","N21 6","N21 5","N14 7","N21 0","N13 4","N21 8","N14 4","N13 5","EN2 0","N14 9","N21 3","EN2 9","N14 6","N21 7","EN2 8","N21 2","EN2 6","N14 8","N14 0","N14 2","N14 1","N14 3"],
        salesRookEmail: "robot+martyngerrardn21@salesrook.com",
    },
    {
        officeName: "Hampstead",
        postCodes: ["NW3 8","NW3 5","NW3 2","NW3 4","NW3 9","NW3 1","NW3 0","NW3 7","NW3 6","NW3 3"],
        salesRookEmail: "robot+martyngerrardnw3@salesrook.com",
    },
    {
        officeName: "Islington",
        postCodes: ["N5 9","E8 4","E8 2","N16 8","EC1V 7","E8 1","N1 1","N1 8","N16 0","N16 7","N16 6","N16 1","N1 7","N1 2","N1 5","E8 3","N1 4","N16 5","N1 0","N16 9","N5 2","N5 1","N1 6","EC1V 1","N1 9","N1 3"],
        salesRookEmail: "robot+martyngerrardn1@salesrook.com",
    },
]

const postcodeMatch = (postCode, values, char) => {
    let emailIds = [];
    postCode.map((item, i) => {
        item.postCodes.map((data, id) => {
            var postCode = data.replace(" ", "")
            var userPostCode = values?.postcode?.replace(" ", "");
            if (userPostCode?.slice(0, char) == postCode) {
                emailIds.push(item.salesRookEmail)
            }
        });
    });

    return emailIds;
};

export const ValuationEmailMatch = (values) => {

    let emailIds = [];
    var userPostCode = values.postcode;
    if(userPostCode && (userPostCode.toLowerCase()?.slice(0,4) == "n2 0" || userPostCode.toLowerCase() == "n2")){ 
        emailIds = ["robot+martyngerrardn2@salesrook.com"]
        return emailIds
    }
    
    emailIds = postcodeMatch(postCode, values, 7);
    if (emailIds.length == 0) {
        emailIds = postcodeMatch(postCode, values, 5);
    }
    if (emailIds.length == 0) {
        emailIds = postcodeMatch(postCode, values, 4);
    }
    if (emailIds.length == 0) {
        emailIds = postcodeMatch(postCode, values, 3);
    }

    if (emailIds.length > 0) {
        return emailIds
    }
    else {
        emailIds = ["HO@martyngerrard.co.uk"]
        return emailIds
    }
}
